import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  TemplateRef,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { isNil } from 'lodash-es';
import { NzTooltipDirective } from 'ng-zorro-antd/tooltip';
import { Subject } from 'rxjs';
import { debounceTime, filter, takeUntil } from 'rxjs/operators';

import { ILabels, IMouseEnterLabelsEvent, ISafeAny } from './label.type';

interface ITooltipPosition {
  left: string;
  top: string;
  width: string;
  height: string;
}

@Component({
  selector: 'bixi-label-tooltip',
  template: `
    <div
      nz-tooltip
      #tooltipRef="nzTooltip"
      class="bixi-label-tooltip"
      [ngStyle]="style"
      [nzTooltipTrigger]="null"
      [nzTooltipTitle]="content ? tooltipContent : defaultContent">
    </div>
    <ng-template #defaultContent>
      <div (mouseenter)="onTooltipOverlayMouseEnter()" (mouseleave)="onTooltipOverlayMouseLeave()" >
        <div *ngFor="let label of labels">{{label.index}}: {{label.word}}</div>
        <div *ngIf="!labels.length">
        -
        </div>
      </div>
    </ng-template>
    <ng-template #tooltipContent>
      <div (mouseenter)="onTooltipOverlayMouseEnter()" (mouseleave)="onTooltipOverlayMouseLeave()">
        <ng-template
          [ngTemplateOutlet]="content"
          [ngTemplateOutletContext]="{$implicit: labels, labels: labels }">
        </ng-template>
      </div>
    </ng-template>
  `,
  exportAs: 'bixiLabelTextTooltip',
  encapsulation: ViewEncapsulation.None,
  preserveWhitespaces: true
})
export class BixiLabelTooltipComponent implements OnInit, OnChanges, OnDestroy {
  @Input() tooltipVisible = false;
  @Input() tooltip: IMouseEnterLabelsEvent;
  @Input() content: TemplateRef<ISafeAny> | undefined;

  @ViewChild('tooltipRef') tooltipRef: NzTooltipDirective;

  labels: ILabels[] = [];
  style: ITooltipPosition | null = null;

  private tooltipDispose$ = new Subject();
  private destroy$ = new Subject();
  private shouldDisplay = false

  constructor() { }

  ngOnInit(): void {
    this.tooltipDispose$.pipe(
      debounceTime(300),
      filter(() => !this.shouldDisplay),
      takeUntil(this.destroy$)
    ).subscribe(() => {
      this.tooltipRef.hide();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    const { tooltipVisible, tooltip } = changes;
    // TODO: refactor
    if (!isNil(tooltipVisible) && !isNil(tooltip)) {
      if ((tooltipVisible.currentValue === true && tooltipVisible.previousValue === false)) {
        // hidden => visible
        this.style = {
          top: `${tooltip.currentValue.position.y}px`,
          left: `${tooltip.currentValue.position.x}px`,
          width: `${tooltip.currentValue.position.width}px`,
          height: `${tooltip.currentValue.position.height}px`
        };
        this.labels = tooltip.currentValue.data;
        this.shouldDisplay = this.labels.length > 0;
        // patch nzTooltip
        setTimeout(() => {
          this.tooltipRef.updatePosition();
          setTimeout(() => {
            if (this.shouldDisplay) {
              this.tooltipRef.show();
            } else {
              this.tooltipRef.hide();
            }
          });
        });
      }
      if (tooltipVisible.currentValue === false && tooltipVisible.previousValue === true) {
        // visible => hidden
        this.shouldDisplay = false;
        this.tooltipDispose$.next();
      }
    }

    // TODO: refactor
    if (!isNil(tooltip) && this.shouldDisplay) {
      this.style = {
        top: `${tooltip.currentValue.position.y}px`,
        left: `${tooltip.currentValue.position.x}px`,
        width: `${tooltip.currentValue.position.width}px`,
        height: `${tooltip.currentValue.position.height}px`
      };
      this.labels = tooltip.currentValue.data;
      this.shouldDisplay = this.labels.length > 0;
      // patch nzTooltip
      setTimeout(() => {
        this.tooltipRef.updatePosition();
        setTimeout(() => {
          if (this.shouldDisplay) {
            this.tooltipRef.show();
          } else {
            this.tooltipRef.hide();
          }
        });
      });
    }
  }

  onTooltipOverlayMouseEnter(): void {
    this.shouldDisplay = true;
  }

  onTooltipOverlayMouseLeave(): void {
    this.shouldDisplay = false;
    this.tooltipDispose$.next();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
